import { render, staticRenderFns } from "./ChangeModeNoteDesktop.vue?vue&type=template&id=39439702&scoped=true&"
import script from "./ChangeModeNoteDesktop.vue?vue&type=script&lang=ts&"
export * from "./ChangeModeNoteDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeModeNoteDesktop.vue?vue&type=style&index=0&id=39439702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39439702",
  null
  
)

export default component.exports